import { fetch } from 'fetch';
import { solutionsUrl } from 'endpoints';

export const apiGetSolutions = async () => {
    try {
        const res = await fetch( `${ solutionsUrl }/solutions`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' }
        } );

        const data = await res.json();

        return data;

    } catch ( error ) {
        throw new Error( error );
    }
};